"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _Checkmark = _interopRequireDefault(require("../Checkmark"));

var RadioButton = function RadioButton(_ref) {
  var options = _ref.options,
      handleChange = _ref.handleChange,
      name = _ref.name,
      valueChecked = _ref.valueChecked;
  return _react["default"].createElement(_style.Container, null, options.map(function (_ref2) {
    var value = _ref2.value,
        text = _ref2.text;
    return _react["default"].createElement(_style.Label, {
      checked: valueChecked === value,
      key: value
    }, _react["default"].createElement(_Checkmark["default"], {
      checked: valueChecked === value
    }), text, _react["default"].createElement(_style.Input, {
      type: "radio",
      name: name,
      onChange: function onChange() {
        return handleChange(value);
      }
    }));
  }));
};

RadioButton.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })).isRequired,
  name: _propTypes["default"].string,
  valueChecked: _propTypes["default"].string.isRequired,
  handleChange: _propTypes["default"].func.isRequired
};
RadioButton.defaultProps = {
  name: 'default'
};
var _default = RadioButton;
exports["default"] = _default;